module.exports = __webpack_public_path__ + "static/media/heart-question-mark.45243d2a.svg";